import { render } from "./proposition-content-input-new.vue?vue&type=template&id=13b76452"
import script from "./proposition-content-input-new.vue?vue&type=script&lang=js"
export * from "./proposition-content-input-new.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__